import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { AppState } from '../../../redux/states/appState'
import { ActivitiesHeaderProps } from '@/app/models/activities'
import { setShowContent } from '../../../redux/actions/activities'

const ActivitiesHeader = (props: ActivitiesHeaderProps) => {
    const { activities, showContent, setShowContent } = props
    const intl = useIntl()

    const activitiesHeaderClass = 'home-activities-header'

    const accordionIconHandler = () => {
        setShowContent(!showContent)
    }

    return (
        <div
            className={`${activitiesHeaderClass} ${
                !showContent ? `${activitiesHeaderClass}--no-margin` : ''
            }`}>
            <div className={`${activitiesHeaderClass}__message`}>
                <h2>
                    {intl.formatMessage({
                        id: 'home.activities.message.your_most_urgent_activities',
                        defaultMessage: 'Your most urgent activities',
                    })}{' '}
                    ({activities.length})
                </h2>
            </div>
            <div
                className={`${activitiesHeaderClass}__accordion-icon`}
                onClick={accordionIconHandler}>
                <i
                    className={`${activitiesHeaderClass}__icon cu cu-caret-up ${
                        !showContent ? 'rotate' : ''
                    }`}></i>
            </div>
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    showContent: state.activitiesReducer.showContent,
    activities: state.mostUrgentActivitiesReducer.activities,
})

const mapDispatchToProps = (dispatch: any) => ({
    setShowContent: (showContent: boolean) => dispatch(setShowContent(showContent)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesHeader)
